<!-- ng-true-value and ng-false-value are missing in Angular2 :-( -->
<div class="control control-checkbox ">
    <label>
        <input [id]="validationIdentifier" type="checkbox" [disabled]="isAlwaysEditable ? false : !isEditable" [ngModel]="currentValue" (ngModelChange)="datafield.Value = $event === true ? 'True' : 'False'; notifyValueChanged(datafield);" /><i></i>
    </label>
</div>
